import React from 'react';
import './Main.scss';
import Products from '../Products/Products';

const Main = () => (
  <main>
    <Products />
  </main>
);

export default Main;
